import { AxiosResponse } from 'axios';
import { CallFlowUuid } from 'resources/CallFlows';
import { LeadSourceUuid } from 'resources/LeadSources';
import { PhoneNumber, PhoneNumberFormat } from 'resources/PhoneNumbers';

import RestAPI from 'components/Common/restApi';

import { CallTrackingNumber, CallTrackingNumberUuid } from '.';

export type IndexParams = {
  pageSize?: number;
  page: number;
  sortDirection: string;
  sortColumn: string;
  q?: string;
};

export type CreateParams = {
  leadSourceUuid: LeadSourceUuid;
  phoneNumber: PhoneNumber<PhoneNumberFormat.Local>;
  destinationNumber: PhoneNumber<PhoneNumberFormat.Local>;
  callFlowUuid?: CallFlowUuid;
};

export type UpdateParams = {
  callTrackingNumberUuid: CallTrackingNumberUuid;
  leadSourceUuid: LeadSourceUuid;
  destinationNumber: PhoneNumber<PhoneNumberFormat.Local>;
  callFlowUuid?: CallFlowUuid;
};

export type DeleteParams = {
  callTrackingNumberUuid: CallTrackingNumberUuid;
};

export type CallTrackingResponse = {
  data: CallTrackingNumber[];
  total_count: number;
};

type Response<T> = Promise<AxiosResponse<T>>;

export default class CallTrackingNumbersApi {
  static index({ pageSize, page, sortDirection, sortColumn, q }: IndexParams): Response<CallTrackingResponse> {
    return RestAPI.getWithQueryString('/alpha/voice/call_tracking_numbers', {
      page_size: pageSize,
      page,
      sort_direction: sortDirection,
      sort_column: sortColumn,
      q,
    });
  }

  static create({
    leadSourceUuid,
    phoneNumber,
    destinationNumber,
    callFlowUuid,
  }: CreateParams): Response<CallTrackingNumber> {
    return RestAPI.postWithFormData('/alpha/voice/call_tracking_numbers', {
      lead_source_uuid: leadSourceUuid,
      call_tracking_number: phoneNumber,
      destination_number: destinationNumber,
      call_flow_uuid: callFlowUuid,
    });
  }

  static update({
    callFlowUuid,
    callTrackingNumberUuid,
    leadSourceUuid,
    destinationNumber,
  }: UpdateParams): Response<CallTrackingNumber> {
    return RestAPI.updateWithFormData(`/alpha/voice/call_tracking_numbers/${callTrackingNumberUuid}`, {
      lead_source_uuid: leadSourceUuid,
      destination_number: destinationNumber,
      call_flow_uuid: callFlowUuid,
    });
  }

  static delete({ callTrackingNumberUuid }: DeleteParams): Response<CallTrackingNumber> {
    return RestAPI.delete(`/alpha/voice/call_tracking_numbers/${callTrackingNumberUuid}`);
  }
}
